"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LicenceExpiredModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LicenceExpiredModal, _Component);

  function LicenceExpiredModal() {
    (0, _classCallCheck3.default)(this, LicenceExpiredModal);
    return (0, _possibleConstructorReturn3.default)(this, (LicenceExpiredModal.__proto__ || (0, _getPrototypeOf2.default)(LicenceExpiredModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(LicenceExpiredModal, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "Ei Aktiivista tilausta", noBottom: true }, this.props),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-8 col-xs-offset-2" },
            _react2.default.createElement(
              "h2",
              { className: "h3 mp-modal-title" },
              "EI AKTIIVISTA TILAUSTA"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/maksullinen-profiili" },
                "Tilaa profiili"
              )
            )
          )
        )
      );
    }
  }]);
  return LicenceExpiredModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired
}, _temp);
exports.default = LicenceExpiredModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/LicenceExpiredModal.js
 ** module id = 1161
 ** module chunks = 0
 **/